import { render, staticRenderFns } from "./InvoiceSettingTab.vue?vue&type=template&id=1c318d6c&scoped=true"
import script from "./InvoiceSettingTab.vue?vue&type=script&lang=js"
export * from "./InvoiceSettingTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSettingTab.vue?vue&type=style&index=0&id=1c318d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c318d6c",
  null
  
)

export default component.exports